import React from 'react';

import { UFOLoadMarkFMP } from './UFOLoadMarkFMP.tsx';

type PageLoadMarkFMPProps = {
	timestamp?: number;
};

/**
 * Component that records a UFO custom FMP mark.
 */
export const PageLoadMarkFMP = (props: PageLoadMarkFMPProps) => {
	return <UFOLoadMarkFMP {...props} />;
};
